import { render } from "./CadastrarCliente.vue?vue&type=template&id=073a7023&scoped=true"
import script from "./CadastrarCliente.vue?vue&type=script&lang=js"
export * from "./CadastrarCliente.vue?vue&type=script&lang=js"

import "./CadastrarCliente.vue?vue&type=style&index=0&id=073a7023&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073a7023"]])

export default __exports__